import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { Column } from '@xingternal/xing-grid';

import { Omit, PdfDescription, PdfPreviewImage } from '@/graphql/generated';

import { PdfPreview } from './pdf-preview';

export type PdfDescriptionProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  __typename: string;
  description: {
    pdfUrl: PdfDescription['pdfUrl'];
    previewImage: Omit<PdfPreviewImage, 'image870x'> & { url: string };
  };
};

type Props = PdfDescriptionProps & WrappedComponentProps;

const PdfDescriptionComponent: React.FC<Props> = ({ description: { pdfUrl, previewImage }, intl }) => (
  <Column size={12}>
    <PdfPreview
      pdfUrl={pdfUrl ?? ''}
      previewUrl={previewImage.url}
      altTitle={intl.formatMessage({ id: 'JOBS_DETAIL_DESCRIPTION_TITLE' })}
    />
  </Column>
);

export default injectIntl(PdfDescriptionComponent);
